const AboutMeSection = () => {
    return (
        <section className="about-me" id="about-me">
            <div className="about-me-inner">
                <img className="about-me-image" src={`${process.env.PUBLIC_URL}/assets/about_me.jpg`} alt="Vidya Sireesha - IPHM Certified Trauma Healing Practitioner" loading="lazy" />
                <div className="about-me-content">
                    <h2 className="about-me-title">About Me</h2>
                    <p className="about-me-text">
                        Hi, I'm Sireesha Katta, an IPHM certified trauma healing practitioner, who works with women navigating childhoos wounds,generational patterns that keeping them stuck in career and relationships.
                    </p>
                    <p className="about-me-text">
                        Have you ever questioned yourself? Who am I beyond this thoughts of mine? are they serving me really!? when i questioned myself with all this, I have discovered, most of our thoughts are inherited, traded from others.For years, I shaped myself to fit into systems that never saw me fully. I learned to shrink, to stay silent, to walk on eggshells. But beneath it all, there was always a voice — gently whispering: There is more.
                    </p>
                    <p className="about-me-text">
                        I help women remember who they truly are beneath the pain, patterns, and pressure. My work is rooted in compassion, nervous system healing, trauma informed therapy and the belief that we don't need to hustle for our worth — we only need to return home to it. I support women in healing generational wounds, reclaiming their voice, and designing lives that feel nourishing, safe, and true.
                    </p>
                    <p className="about-me-text">
                        I believe healing is slow, sacred, and deeply personal. I believe we have different parts inside us, all of them made us who we are and that even the smallest act of self-love creates ripples across generations.
                    </p>
                    <p className="about-me-text font-semibold">
                        If you're ready to rewrite your story, come home to yourself, and live fully expressed — I'm here. Let's walk together.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutMeSection;
